module.exports = __webpack_public_path__ + "img/14.29333eb2.jpg";